module.exports = __webpack_public_path__ + "static/media/website_publish_confetti.e4c803be.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/website_publish_confetti.svg
 ** module id = 2092
 ** module chunks = 44
 **/